import { useContext } from 'react';
import { highlightListContext } from './context';

export const useCurrentHighlightList = () => {
  const currentHighlightList = useContext(highlightListContext);
  return currentHighlightList;
};
